"use client";

import { ArrowRight, Sparkles } from "lucide-react";
import { usePathname } from "next/navigation";
import TranslationFriendlyLink from "@/components/TranslationFriendlyLink";

const AWS_SERVICE_PATHS = [
    "/",
    "/rds",
    "/elasticache",
    "/redshift",
    "/opensearch",
];

function isPathOrChild(pathname: string, path: string) {
    return pathname === path || pathname.startsWith(`${path}/`);
}

export default function CloudSavingsBanner() {
    const pathname = usePathname();
    const isAzure = isPathOrChild(pathname, "/azure");
    const isGcp = isPathOrChild(pathname, "/gcp");
    const isAws =
        pathname.startsWith("/aws/") ||
        AWS_SERVICE_PATHS.some((path) =>
            path === "/" ? pathname === path : isPathOrChild(pathname, path),
        );

    if (!isAws && !isAzure && !isGcp) return null;

    const providerLabel = isAzure
        ? "Azure VMs"
        : isGcp
          ? "GCP instances"
          : "AWS instances";
    const href = isAzure
        ? "https://bigbell.ai/lp/azure"
        : isGcp
          ? "https://bigbell.ai/lp/gcp"
          : "https://bigbell.ai/lp/aws";

    return (
        <TranslationFriendlyLink
            href={href}
            className="group flex min-h-11 items-center justify-center gap-2 bg-[#0D172A] px-4 py-2 text-center text-sm font-medium text-white transition-colors hover:bg-[#16243B] focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-white"
        >
            <Sparkles
                aria-hidden="true"
                className="h-4 w-4 shrink-0 text-[#FA8300]"
            />
            <span>
                Comparing {providerLabel} to save money? Get a free cloud cost
                review.
            </span>
            <ArrowRight
                aria-hidden="true"
                className="h-4 w-4 shrink-0 transition-transform group-hover:translate-x-1"
            />
        </TranslationFriendlyLink>
    );
}
